/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 332);
/******/ })
/************************************************************************/
/******/ ({

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(333);


/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable no-inner-declarations */

function throttle(fn, threshholdMs) {
  var last = void 0;
  var deferTimer = void 0;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var now = Date.now();
    if (last && now < last + threshholdMs) {
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(undefined, args);
      }, threshholdMs);
    } else {
      last = now;
      fn.apply(undefined, args);
    }
  };
}

if (!window.nrkValgStaticSizeElements) {
  var parseSizes = function parseSizes(queryUnparsed) {
    return queryUnparsed.split(',').map(function (size) {
      var operands = size.split('=');
      return { name: operands[0], width: parseInt(operands[1], 10) };
    });
  };

  var sizeElement = function sizeElement(element) {
    requestAnimationFrame(function () {
      var elementWidth = element.clientWidth;
      var queryUnparsed = element.getAttribute('data-element-query') || '';
      var size = parseSizes(queryUnparsed).filter(function (size) {
        return size.width <= elementWidth;
      })[0];
      element.className = size ? size.name : '';
    });
  };

  var sizeElements = function sizeElements() {
    var divs = document.querySelectorAll('[data-element-query]');
    var i = void 0;
    for (i = 0; i < divs.length; ++i) {
      sizeElement(divs[i]);
    }
  };

  var handleResize = function handleResize() {
    if (frame) {
      cancelAnimationFrame(frame);
    }
    frame = requestAnimationFrame(sizeElements);
  };

  var frame = void 0;


  window.addEventListener('resize', throttle(handleResize, 50));
  window.addEventListener('orientationchange', throttle(handleResize, 50));
  window.nrkValgStaticSizeElement = sizeElement;
  window.nrkValgStaticSizeElements = sizeElements;
}

// Resize elements initially (for Kurator)
window.nrkValgStaticSizeElements();

/***/ })

/******/ });


// WEBPACK FOOTER //
// elementQuery-9cf0bb.js